"use client";

import { getLink } from "@utils/linkUtils";
import { useLocale, useTranslations } from "next-intl";
import Image from "next/image";
import { FC, useState } from "react";
import { Tab, TabList, TabPanel, Tabs } from "react-tabs";

import Button, { ButtonSize, ButtonTheme, ButtonVariant } from "@/components/ui/Button/Button";
import { Article, ArticleSorting, DHubIntroProps, ImageElement } from "@/types";

import loadArticles from "../ArticleListing/loadArticles";
import DHubArticles from "./DHubArticles";

export interface Props {
  entry: DHubIntroProps;
}

const DHubIntro: FC<Props> = ({ entry }) => {
  const t = useTranslations();
  const locale = useLocale();
  const [articles, setArticles] = useState<Article[]>(entry.articleList ? entry.articleList : []);

  return (
    <div className="p-m md:p-0' w-full md:w-20\/24 mx-auto my-xl">
      <div>
        <Image src={entry.logo.url} alt={entry.logo.title || ""} width={180} height={65} className="mx-auto" />
      </div>
      <Tabs>
        <TabList className="my-l text-center">
          <Tab key="tab-all">{t("all")}</Tab>
          {entry.tabs.map((tab, index) => (
            <Tab
              key={`tab-${index}`}
              onClick={() => {
                loadArticles(5, tab.articlesType, tab.sorting === ArticleSorting.featured).then((res) => {
                  setArticles(res);
                });
              }}
            >
              <span className="capitalize">{tab.title}</span>
            </Tab>
          ))}
        </TabList>
        <TabPanel key={`tab-all`}>
          <DHubArticles articles={entry.articleList} fallbackImage={entry.fallbackImage} />
          {!!entry.cta && (
            <div className="text-center mt-xl">
              <Button
                href={getLink(entry.cta, locale)}
                size={ButtonSize.MEDIUM}
                variant={ButtonVariant.PRIMARY}
                theme={ButtonTheme.BLACK}
                customClass="inline-block"
              >
                {entry.cta.label}
              </Button>
            </div>
          )}
        </TabPanel>
        {entry.tabs.map((tab, index) => (
          <TabPanel key={`tab-${index}`}>
            <DHubArticles articles={articles} fallbackImage={entry.fallbackImage} />
            {!!tab.cta && (
              <div className="text-center mt-xl">
                <Button
                  href={getLink(tab.cta, locale)}
                  size={ButtonSize.MEDIUM}
                  variant={ButtonVariant.PRIMARY}
                  theme={ButtonTheme.BLACK}
                  customClass="inline-block"
                >
                  {tab.cta.label}
                </Button>
              </div>
            )}
          </TabPanel>
        ))}
      </Tabs>
    </div>
  );
};

export default DHubIntro;
